<script lang="ts">
  import { type TaskData } from "../lib/tasks";
  import TaskList from "./MatterCard/TaskList.svelte";

  let { tasks }: { tasks: TaskData[] } = $props();
</script>

<TaskList tasks={tasks} />
